import React, { Fragment } from 'react';

import {
  StyledInputContainer,
  StyledEmailLabelP,
  StyledPasswordLabelP,
  StyledInput,
  StyledActionsContainer,
  StyledButton,
  StyledATag,
  ButtonContainerStyled,
} from 'helpers/StyledLoginComponentsHelper';
import { getTranslatedString } from 'helpers/i18n';
import { AccentColor } from 'helpers/AccentColorHelper';

export default props => {
  const { details } = props;
  return (
    <Fragment>
      <StyledInputContainer>
        <StyledEmailLabelP>{getTranslatedString('email')}</StyledEmailLabelP>
        <StyledInput
          data-testid="login-email-input"
          name="username"
          type="text"
          placeholder="example@email.com"
          onChange={props.handleInputChange}
          value={details.username}
          onKeyDown={props.detectEnterKeyDown}
        />
        <StyledPasswordLabelP>{getTranslatedString('password')}</StyledPasswordLabelP>
        <StyledInput
          data-testid="login-password-input"
          name="password"
          type="password"
          placeholder="&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;"
          onChange={props.handleInputChange}
          value={details.password}
          onKeyDown={props.detectEnterKeyDown}
        />
      </StyledInputContainer>
      <StyledActionsContainer mobile={props.mobile}>
        <ButtonContainerStyled mobile={props.mobile}>
          <StyledButton
            name="submit"
            inputProps={{ 'aria-label': getTranslatedString('login') }}
            data-testid="login-button"
            id={'login-button'}
            primary={true}
            onClick={props.login}
            accentColor={AccentColor()}
            disabled={!details.isButtonEnabled}
            labelStyle={{ textTransform: 'capitalize', fontSize: '18px' }}
            mobile={props.mobile}
          >
            {getTranslatedString('login')}
          </StyledButton>
        </ButtonContainerStyled>
        <ButtonContainerStyled mobile={props.mobile}>
          <StyledATag href={`/${props.passwordResetURL}`}>
            {getTranslatedString('forgotPassword')}
          </StyledATag>
        </ButtonContainerStyled>
      </StyledActionsContainer>
    </Fragment>
  );
};
